import script from "./BaseAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseAccordion.vue?vue&type=script&setup=true&lang=ts"

import "./BaseAccordion.vue?vue&type=style&index=0&id=20aae3df&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20aae3df"]])

export default __exports__